export const LOGIN_REDUCER_STATE_ID = 'login';
